export class FormSelectItem {
    id?: number;
    name?: string;
    selectable?: boolean;
}
